// Used by QA to trigger the error boundary
const TestErrorBoundaryPage = () => {
  throw new Error('Something went wrong');
};

export default TestErrorBoundaryPage;
